import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import AmenityDetail from './AmenityDetail';
import action from "../../../../../actions";
import * as amenityActions from './../../../../../actions/amenityAction';

const mapStateToProps = state => {
    return {
        file: state.uploadReducer,
        amenityState: state.amenityReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onUploadFile: (filters) => dispatch(action.uploadAction(filters)),
        getAmenityDetail: (id) => dispatch(amenityActions.getAmenityDetail(id)),
        setAmenityDetail: (amenity) => dispatch(amenityActions.setAmenityDetail(amenity)),
        updateAmenityDetail: (amenity) => dispatch(amenityActions.updateAmenityDetail(amenity)),
        createAmenityDetail: (amenity) => dispatch(amenityActions.createAmenityDetail(amenity)),
        createAmenityTranslate: (amenity, language) => dispatch(amenityActions.createAmenityTranslate(amenity, language)),
        updateAmenityTranslate: (amenity, language) => dispatch(amenityActions.updateAmenityTranslate(amenity, language)),
        deleteAmenityTranslate: (amenity, refreshParams) => dispatch(amenityActions.deleteAmenityTranslate(amenity, refreshParams)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(AmenityDetail));
